/**
 *  UI-REFACTORED
 *    FROM --> ./legacy-web/src/main/js/release/serviceTransactions.js
 *    TO   --> ./legacy-web/src/main/assets/js/release/service-transactions.js
 **/

//@author Jose Victor Antonio Riquelme

function encode(inputString) {
    var encodedInputString = escape(inputString);
    encodedInputString = encodedInputString.replace(/\+/g, "%2B");
    encodedInputString = encodedInputString.replace(/\//g, "%2F");
    return encodedInputString;
}

function createInput(doc, myform, type, name, value) {
    var txt = doc.createElement("input");
    txt.type = type;
    txt.name = name;
    if(value != "") {
        txt.value = value;
    }
    txt.style.display = 'none';
    myform.appendChild(txt);
    return txt;
}

function createForm(doc, action) {
    var myform = doc.createElement("form");
    myform.id = 'myForm';
    myform.method = "POST";
    if(action != "") {
        myform.action = action;
    }
    return myform;
}

function replaceAll(txt, replace, with_this) { return txt.replace(new RegExp(replace, 'g'), with_this);}

//	function replaceAll(str,textToReplace,replacement){
//		var strReplaceAll = str;
//		var intIndexOfMatch = strReplaceAll.indexOf( textToReplace );
//
//		while (intIndexOfMatch != -1){
//			strReplaceAll = strReplaceAll.replace( textToReplace, replacement )
//			intIndexOfMatch = strReplaceAll.indexOf( textToReplace );
//		}
//		return strReplaceAll;
//	}

function reload() {
    window.location.reload();
}

/**
 * This function send to user a file containing the content in HTML format.
 * @param doc
 * @param contentHTML
 * @param filename
 */
function downloadFile(doc, contentHTML, filename) {
    var myform = createForm(doc, "/release/downloadHTML.jsp");

    contentHTML = replaceAll(contentHTML, "\n", "<br>");
    contentHTML = replaceAll(contentHTML, "<", "[");
    contentHTML = replaceAll(contentHTML, ">", "]");
    contentHTML = replaceAll(contentHTML, '&lt;', '[');
    contentHTML = replaceAll(contentHTML, '&gt;', ']');

    createInput(doc, myform, "text", "content", contentHTML);
    createInput(doc, myform, "text", "filename", filename);
    createInput(doc, myform, "submit", "action", "Download");

    doc.body.appendChild(myform);
    myform.submit();
}

function serviceAvailability() {
    window.open("/release/framework.jsp?index=0&type=servicesAvailability");
}
